import Image from "next/legacy/image";
import { useRef, useState } from "react";
import { CheckLine, swc } from "@teamsparta/design-system";

import { courseName, courseOnlineClass } from "src/models/apply";

import * as S from "./LandingPagePriceOrganism.style";
import questionIcon from "public/images/landing/price/question_icon.svg";
import cardIcon from "public/images/landing/price/card_icon.svg";
import cardCompanies from "public/images/landing/price/card_companies.svg";
import { Price } from "@/api/price/price.dto";

export let priceRef;

const LandingPagePriceOrganism = ({
  course,
  price,
}: {
  course: string;
  price: Price;
}) => {
  priceRef = useRef();
  const [isShown, setIsShown] = useState(false);
  const isEarlyBirdSeason = price ? price.policy?.includes("earlybird") : false;
  const totalPrice = price ? price.price / 10000 : 330;
  const monthlyPrice = price ? Math.floor(price.price / 120000) : 27;

  return (
    <S.Wrapper ref={priceRef}>
      <S.TextSection>
        <S.Title>수강료 안내</S.Title>
        <S.SubTitle>
          새로운 커리어의 막을 여실 수 있도록,
          <br />
          SW캠프가 적극 지원하겠습니다.
        </S.SubTitle>
        <S.BenefitTitleSection>
          <CheckLine size={16} color={`${swc.blue}`} />
          <S.BenefitTitle>합류 시 사전 스터디 혜택</S.BenefitTitle>
        </S.BenefitTitleSection>
        <S.BenefitList>
          <S.Benefit>50만 원 상당 {courseOnlineClass[course]} 제공</S.Benefit>
          <S.Benefit>{courseName[course]} 기초 이론 북스터디 진행</S.Benefit>
        </S.BenefitList>
      </S.TextSection>
      <S.PriceCard>
        <S.CourseWeek>12주 코스</S.CourseWeek>
        {isEarlyBirdSeason && <S.OriginalPrice>330만 원</S.OriginalPrice>}
        <S.PriceSection>
          <S.DiscountPrice>{totalPrice}만 원</S.DiscountPrice>
          {isEarlyBirdSeason && (
            <S.EarlyBirdeBadge>
              {price.policy.includes("-1")
                ? "1차 얼리버드 할인가"
                : "2차 얼리버드 할인가"}
            </S.EarlyBirdeBadge>
          )}
        </S.PriceSection>
        <S.InstallmentPrice>
          12개월 할부 시 <strong>월 {monthlyPrice}만 원</strong>
        </S.InstallmentPrice>
        <S.Divider />
        <S.InstallmentInfoTitleSection>
          <S.InstallmentInfoTitle>
            <S.CardIconWrapper>
              <Image
                src={cardIcon}
                layout="fill"
                objectFit="cover"
                alt="card_icon"
              />
            </S.CardIconWrapper>
            12개월 무이자 할부 가능
          </S.InstallmentInfoTitle>
          <S.CardCompanyList
            onMouseEnter={() => setIsShown(true)}
            onMouseLeave={() => setIsShown(false)}
          >
            {isShown && (
              <S.CardCompaniesImage>
                <Image
                  src={cardCompanies}
                  layout="fill"
                  objectFit="cover"
                  alt="card_company"
                  unoptimized={true}
                />
              </S.CardCompaniesImage>
            )}
            카드사 확인
            <Image
              src={questionIcon}
              width={20}
              height={20}
              alt="question_icon"
            />
          </S.CardCompanyList>
        </S.InstallmentInfoTitleSection>
        <S.InstallmentDesc>
          SW캠프에서는 12개월 무이자 할부가
          <S.MobileBr />
          가능합니다. <S.DesktopBr />
          부담없이 커리어 전환을 시작하세요.
        </S.InstallmentDesc>
      </S.PriceCard>
    </S.Wrapper>
  );
};

export default LandingPagePriceOrganism;
